import { Outlet } from "react-router-dom";
import { useAdminLoading } from "../../../context/AdminLoadingContext";
import AdminLayoutSideBar, {
  sidebarData,
  type SidebarItem,
} from "./AdminLayoutSideBar";
import Header from "./AdminLayoutHeader";
import AdminLayoutGlobalLoading from "./AdminLayoutGlobalLoading";

const SIDEBAR_ENABLED_HEAD = 3;
const SIDEBAR_ENABLED_TAIL = 8;

const getEnabledSidebarItemIds = (items: SidebarItem[]) => {
  const enabledItems = [
    ...items.slice(0, SIDEBAR_ENABLED_HEAD),
    ...items.slice(-SIDEBAR_ENABLED_TAIL),
  ];

  return new Set(enabledItems.map((item) => item.id));
};

export default function AdminLayout() {

  const { isLoading } = useAdminLoading();
  let role: number | null = null;
  const profileInfo = localStorage.getItem("profileInfo");
  if (profileInfo) {
    try {
      role = JSON.parse(profileInfo)?.role ?? null;
    } catch {
      role = null;
    }
  }
  const isRestrictedRole = role === 6;
  const enabledSidebarItemIds = getEnabledSidebarItemIds(sidebarData);

  return (
      <div className="flex flex-col relative">
        {isLoading && <AdminLayoutGlobalLoading />}
        <div className="w-full h-14 fixed flex items-center px-16 2xl:px-32 border-b card-shadow bg-white z-50">
          <Header />
        </div>
        <div className=" flex flex-row gap-6 mt-16 mb-10 mx-20" dir="rtl">
          <div className=" w-[250px] h-auto bg-white border border-gray-200 py-4 px-3 rounded-2xl flex-shrink-0">
            <AdminLayoutSideBar
              items={sidebarData}
              enabledItemIds={enabledSidebarItemIds}
              isRestrictedRole={isRestrictedRole}
            />
          </div>
          <div className="flex-1 min-w-0">
            <Outlet />
          </div>
        </div>
      </div>
  );
};